/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：795
 */

"use strict"

export { a }
import * as /* [auto-meaningful-name] */Module_21 from /* 21 */"./21"
var o = "".concat("accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap", " ").concat("onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError").split(/[\s\n]+/)
function i(e, t) {
  return 0 === e.indexOf(t)
}
function a(e) {
  var t
  var n = arguments.length > 1 && undefined !== arguments[1] && arguments[1]
  t = false === n ? {
    aria: true,
    data: true,
    attr: true
  } : true === n ? {
    aria: true
  } : Module_21.a({}, n)
  var a = {}
  Object.keys(e).forEach(function (n) {
    if (t.aria && ("role" === n || i(n, "aria-")) || t.data && i(n, "data-") || t.attr && o.includes(n)) {
      a[n] = e[n]
    }
  })
  return a
}
export default a
